import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, query, where, onSnapshot, deleteDoc, doc, updateDoc, getDocs } from "firebase/firestore";
import Seite from "../components/Seite";
import Notizzettel from "../components/Notizzettel";
import MikrofonButton from "../components/MikrofonButton";

function ProjektAuswahl({ user, onWaehlen }) {
  const [projekte, setProjekte] = useState([]);
  useEffect(() => {
    (async () => {
      const snap = await getDocs(query(collection(db, "projekte"), where("uid", "==", user.uid)));
      setProjekte(snap.docs.map((d) => ({ id: d.id, titel: d.data().titel })));
    })();
  }, [user.uid]);

  return (
    <select style={styles.projektSelect} onChange={(e) => e.target.value && onWaehlen(e.target.value)} defaultValue="">
      <option value="" disabled>Projekt wählen...</option>
      <option value="__neu__">+ Neues Projekt erstellen</option>
      {projekte.map((p) => <option key={p.id} value={p.id}>{p.titel}</option>)}
    </select>
  );
}

const KATEGORIEN = [
  { id: "alle", label: "Alle" },
  { id: "beruflich", label: "💼 Beruflich" },
  { id: "privat", label: "🏠 Privat" },
];

export default function Notizen({ user }) {
  const [notizen, setNotizen] = useState([]);
  const [neu, setNeu] = useState("");
  const [neueKategorie, setNeueKategorie] = useState("beruflich");
  const [filterKategorie, setFilterKategorie] = useState("alle");
  const [editId, setEditId] = useState(null);
  const [editText, setEditText] = useState("");
  const [notizzettelId, setNotizzettelId] = useState(null);
  const [verschiebenId, setVerschiebenId] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "notizen"), where("uid", "==", user.uid));
    return onSnapshot(q, (snap) => setNotizen(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
  }, [user.uid]);

  const hinzufuegen = async (e) => {
    e.preventDefault();
    if (!neu.trim()) return;
    await addDoc(collection(db, "notizen"), {
      text: neu, uid: user.uid, notiz: {}, kategorie: neueKategorie, erstellt: new Date(),
    });
    setNeu("");
  };

  const editSpeichern = async (id) => {
    await updateDoc(doc(db, "notizen", id), { text: editText });
    setEditId(null);
  };

  const notizzettelSpeichern = async (notizDaten) => {
    await updateDoc(doc(db, "notizen", notizzettelId), { notiz: notizDaten });
  };

  const aktiveNotiz = notizen.find((n) => n.id === notizzettelId);

  const zuProjektVerschieben = async (notiz, projektId) => {
    const neuerUnterpunkt = {
      text: notiz.text, erledigt: false, id: Date.now().toString(),
      prioritaet: "mittel", erledigtBis: "", notiz: notiz.notiz || {},
    };
    if (projektId === "__neu__") {
      await addDoc(collection(db, "projekte"), {
        titel: notiz.text, unterpunkte: [neuerUnterpunkt],
        uid: user.uid, reihenfolge: Date.now(), erstellt: new Date(),
      });
    } else {
      const snap = await getDocs(query(collection(db, "projekte"), where("uid", "==", user.uid)));
      const projektDoc = snap.docs.find((d) => d.id === projektId);
      if (projektDoc) {
        const bisherige = projektDoc.data().unterpunkte || [];
        await updateDoc(doc(db, "projekte", projektId), { unterpunkte: [...bisherige, neuerUnterpunkt] });
      }
    }
    await deleteDoc(doc(db, "notizen", notiz.id));
    setVerschiebenId(null);
  };

  const gefilterteNotizen = filterKategorie === "alle"
    ? notizen
    : notizen.filter((n) => (n.kategorie || "beruflich") === filterKategorie);

  return (
    <Seite titel="Notizen">
      {aktiveNotiz && (
        <Notizzettel
          key={notizzettelId}
          titel={aktiveNotiz.text}
          notiz={aktiveNotiz.notiz || {}}
          onSpeichern={notizzettelSpeichern}
          onSchliessen={() => setNotizzettelId(null)}
          storagePfad="notizen"
        />
      )}

      {/* Kategorie-Filter */}
      <div style={styles.filterLeiste}>
        {KATEGORIEN.map((k) => (
          <button
            key={k.id}
            style={{ ...styles.filterBtn, ...(filterKategorie === k.id ? styles.filterBtnAktiv : {}) }}
            onClick={() => setFilterKategorie(k.id)}
          >
            {k.label}
          </button>
        ))}
      </div>

      <form onSubmit={hinzufuegen} style={styles.form}>
        <input style={styles.input} value={neu} onChange={(e) => setNeu(e.target.value)} placeholder="Neue Notiz..." />
        <MikrofonButton onText={(t) => setNeu((prev) => prev + (prev ? " " : "") + t)} />
        <select style={styles.kategorieSelect} value={neueKategorie} onChange={(e) => setNeueKategorie(e.target.value)}>
          <option value="beruflich">💼 Beruflich</option>
          <option value="privat">🏠 Privat</option>
        </select>
        <button style={styles.button} type="submit">Hinzufügen</button>
      </form>

      {gefilterteNotizen.length === 0 && <p style={styles.leer}>Keine Notizen in dieser Kategorie.</p>}
      {gefilterteNotizen.map((n) => (
        <div key={n.id} style={styles.eintragWrapper}>
          <div style={styles.eintrag}>
            {editId === n.id ? (
              <>
                <input style={{ ...styles.input, flex: 1 }} value={editText} onChange={(e) => setEditText(e.target.value)} autoFocus />
                <button style={styles.speichern} onClick={() => editSpeichern(n.id)}>💾</button>
                <button style={styles.abbrechen} onClick={() => setEditId(null)}>✕</button>
              </>
            ) : (
              <>
                <button
                  style={{ ...kategorieBadgeStyle(n.kategorie || "beruflich"), border: "none", cursor: "pointer" }}
                  title="Kategorie wechseln"
                  onClick={() => updateDoc(doc(db, "notizen", n.id), { kategorie: (n.kategorie || "beruflich") === "beruflich" ? "privat" : "beruflich" })}
                >
                  {(n.kategorie || "beruflich") === "beruflich" ? "💼" : "🏠"}
                </button>
                <span style={{ flex: 1 }}>{n.text}</span>
                {(n.notiz?.text || n.notiz?.bilder?.length > 0 || n.notiz?.zeichnung || n.notiz?.dokumente?.length > 0 || n.notiz?.links?.length > 0) && (
                  <span title="Hat Anhänge" style={{ color: "#1a73e8", fontSize: "0.8rem" }}>📋</span>
                )}
                <button style={styles.iconBtn} onClick={() => setNotizzettelId(n.id)} title="Notizzettel öffnen">📋</button>
                <button style={styles.iconBtn} onClick={() => { setEditId(n.id); setEditText(n.text); }} title="Bearbeiten">✏️</button>
                <button style={styles.iconBtn} onClick={() => setVerschiebenId(verschiebenId === n.id ? null : n.id)} title="Zu Projekt verschieben">📁</button>
                <button style={styles.iconBtn} onClick={() => deleteDoc(doc(db, "notizen", n.id))} title="Löschen">🗑️</button>
              </>
            )}
          </div>
          {verschiebenId === n.id && (
            <div style={styles.verschiebenBox}>
              <ProjektAuswahl user={user} onWaehlen={(projektId) => zuProjektVerschieben(n, projektId)} />
            </div>
          )}
        </div>
      ))}
    </Seite>
  );
}

function kategorieBadgeStyle(kat) {
  return {
    fontSize: "0.85rem",
    padding: "0.15rem 0.35rem",
    borderRadius: "4px",
    backgroundColor: kat === "beruflich" ? "#e8f0fe" : "#fce8f3",
    flexShrink: 0,
  };
}

const styles = {
  form: { display: "flex", gap: "0.5rem", marginBottom: "1rem", flexWrap: "wrap" },
  input: { flex: 1, padding: "0.6rem", fontSize: "1rem", border: "1px solid #ccc", borderRadius: "4px", minWidth: "120px" },
  button: { padding: "0.6rem 1rem", backgroundColor: "#1a73e8", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" },
  kategorieSelect: { padding: "0.5rem 0.6rem", border: "1px solid #ccc", borderRadius: "4px", fontSize: "0.9rem" },
  filterLeiste: { display: "flex", gap: "0.5rem", marginBottom: "1rem", flexWrap: "wrap" },
  filterBtn: { padding: "0.4rem 0.9rem", border: "1px solid #ddd", borderRadius: "20px", cursor: "pointer", fontSize: "0.85rem", backgroundColor: "white", color: "#555" },
  filterBtnAktiv: { backgroundColor: "#1a73e8", color: "white", borderColor: "#1a73e8" },
  eintragWrapper: { marginBottom: "0.5rem" },
  eintrag: { display: "flex", alignItems: "center", gap: "0.5rem", padding: "0.8rem", backgroundColor: "white", borderRadius: "4px", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" },
  verschiebenBox: { padding: "0.5rem 0.8rem", backgroundColor: "#f8f9fa", borderRadius: "0 0 4px 4px" },
  projektSelect: { padding: "0.4rem 0.6rem", border: "1px solid #ddd", borderRadius: "4px", fontSize: "0.85rem", width: "100%" },
  iconBtn: { background: "none", border: "none", cursor: "pointer", fontSize: "1rem" },
  speichern: { padding: "0.3rem 0.6rem", backgroundColor: "#34a853", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" },
  abbrechen: { padding: "0.3rem 0.6rem", backgroundColor: "#ea4335", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" },
  leer: { color: "#999", textAlign: "center" },
};
